import React from 'react';
import { CheckCircle2, XCircle, Star, ShieldCheck, Zap, FileText, BookOpen, Settings, ArrowRight, AlertTriangle } from 'lucide-react';
import { Accordion } from './components/Accordion';
import { Countdown } from './components/Countdown';
import { HeroReviewCarousel } from './components/HeroReviewCarousel';
import { ModuleCarousel } from './components/ModuleCarousel';
import { PurchasePopup } from './components/PurchasePopup';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59843956605009:1';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/uEhmtnBCo1q3uap1QTBZRq/ChatGPT_Image_Jul_3__2026__11_37_10_PM-removebg-preview.png';
// Bonus preview images
const IMG_1 = 'https://cdn.magicpatterns.com/uploads/uyHozA9F8qceFHj7mV3a65/Screenshot_2026-07-04_at_4.04.02_AM.png';
const IMG_3 = 'https://cdn.magicpatterns.com/uploads/6cBHUapR9vrALwBhkTMpC2/Screenshot_2026-07-04_at_4.05.10_AM.png';
const IMG_4 = 'https://cdn.magicpatterns.com/uploads/mnw84YFSghADzjt1K4PaQh/Screenshot_2026-07-04_at_4.23.57_AM.png';

// Module preview images, assigned in uploaded order.
const MODULE_IMG_1 = 'https://cdn.magicpatterns.com/uploads/u77S3WxKXT6GSSgp2RqhoX/ChatGPT_Image_Jul_19,_2026,_02_47_03_AM.png';
const MODULE_IMG_2 = 'https://cdn.magicpatterns.com/uploads/6qLEvRZ9WQEibb5qSAmHTL/ChatGPT_Image_Jul_19,_2026,_02_47_13_AM.png';
const MODULE_IMG_3 = 'https://cdn.magicpatterns.com/uploads/cGZqfm8Mn9bm6yAxSKQ3BL/ChatGPT_Image_Jul_19,_2026,_02_47_16_AM.png';
const MODULE_IMG_4 = 'https://cdn.magicpatterns.com/uploads/dAhhJ7fM4agTXxDXp5J9w2/ChatGPT_Image_Jul_19,_2026,_02_47_18_AM.png';
const MODULE_IMG_5 = 'https://cdn.magicpatterns.com/uploads/w79BxPkZC1Mz1ewgkxUZkJ/ChatGPT_Image_Jul_19,_2026,_02_47_21_AM.png';
const MODULE_IMG_6 = 'https://cdn.magicpatterns.com/uploads/1P5r2e4YKPGWCaPKi6Quwo/ChatGPT_Image_Jul_19,_2026,_02_59_37_AM.png';
const MODULE_IMG_7 = 'https://cdn.magicpatterns.com/uploads/2oUaSLnuXJNJSrs4Hj6HBh/ChatGPT_Image_Jul_19,_2026,_03_01_01_AM.png';
const MODULES = [{
  title: '🧠 Módulo 1: El Rol del Arquero — Qué lo Diferencia del Resto del Equipo',
  image: MODULE_IMG_1,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-0" data-mp="d4nvlgp3tk2e">
        <li data-id="element-1" data-mp="d3cw3t2oyyh3">
          Por qué el arquero es el único jugador del equipo que no puede
          desconcentrarse ni un segundo, ni cuando la pelota está en el otro
          arco
        </li>
        <li data-id="element-2" data-mp="3gmfuzg5kl6am">
          Las 3 responsabilidades centrales: parar, salir bien y liderar la
          defensa desde atrás
        </li>
        <li data-id="element-3" data-mp="3bk6zod585s5c">
          Qué espera el equipo del arquero que nunca te van a decir en voz alta
        </li>
        <li data-id="element-4" data-mp="3qdajkr6aghz8">
          La diferencia entre un arquero reactivo y un arquero que lee el juego
          antes de que pase
        </li>
      </ul>
}, {
  title: '📍 Módulo 2: Postura Base y Posicionamiento en el Arco',
  image: MODULE_IMG_2,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-5" data-mp="2sv0pxfmesavo">
        <li data-id="element-6" data-mp="18drk5y5ejjev">
          La postura base: por qué los pies determinan todo lo demás antes de
          que la pelota salga de la mano del lanzador
        </li>
        <li data-id="element-7" data-mp="1d62hquco6t49">
          Apertura de pies, flexión de rodillas y centro de gravedad bajo: cómo
          construir la base correcta
        </li>
        <li data-id="element-8" data-mp="13eexbdej6cca">
          Las manos: dónde ponerlas, por qué no cruzarlas y cómo dejarlas listas
          para reaccionar en cualquier dirección
        </li>
        <li data-id="element-9" data-mp="1r4sf8b3eiut5">
          La mirada: enfoque en el lanzador, no en la pelota, hasta el último
          décimo de segundo
        </li>
        <li data-id="element-10" data-mp="1i3ku6upwbqh0">
          Posicionamiento según el ángulo de tiro: cómo achicar el arco sin
          regalarte el lado contrario
        </li>
        <li data-id="element-11" data-mp="1m44q5uyqgo1k">
          Posicionamiento desde el extremo izquierdo y derecho: dónde pararte y
          qué zona dejás expuesta
        </li>
        <li data-id="element-12" data-mp="6qictxfz2wvs">
          Posicionamiento desde el centro (pivote, central): el más difícil
          porque el eje cambia todo el tiempo
        </li>
        <li data-id="element-13" data-mp="qxf89rj6z5it">
          Posicionamiento en 9 metros y jugadas de superioridad numérica del
          rival
        </li>
        <li data-id="element-14" data-mp="m5nel84qojog">
          Los 5 errores de posicionamiento más comunes que regalan goles
          evitables
        </li>
      </ul>
}, {
  title: '🧤 Módulo 3: Técnica de Atajada por Zona',
  image: MODULE_IMG_3,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-15" data-mp="c6enqo567l6b">
        <li data-id="element-16" data-mp="19uyj90p7my7v">
          Por qué la atajada no es un reflejo puro sino una técnica que se puede
          entrenar y automatizar
        </li>
        <li data-id="element-17" data-mp="14uu1768nlvfj">
          <strong data-id="element-18" data-mp="14v3q0qhypwjn">Zona Alta:</strong> Mecánica del brazo dominante, timing del
          salto, atajada alta cruzada y progresión de drills.
        </li>
        <li data-id="element-19" data-mp="vvgps80yyws6">
          <strong data-id="element-20" data-mp="vvp1hwlcvw1s">Zona Baja:</strong> La caída controlada, pierna que barre vs
          soporta, atajada baja cruzada y recuperación inmediata.
        </li>
        <li data-id="element-21" data-mp="3gly1s0ax4od9">
          <strong data-id="element-22" data-mp="3gm7p1g4kwhf9">Zona Lateral:</strong> Desplazamiento lateral explosivo,
          atajada con extensión completa en tiros de extremo.
        </li>
        <li data-id="element-23" data-mp="1w2c53g66ec79">
          <strong data-id="element-24" data-mp="2060bhvj2n1qx">Contraataque y 1 vs. 1:</strong> Cómo salir del arco, lectura
          del lanzador, el achique en carrera y el error más caro.
        </li>
      </ul>
}, {
  title: '⚡ Módulo 4: Reflejos y Tiempo de Reacción — Cómo Entrenarlos',
  image: MODULE_IMG_4,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-25" data-mp="2euwtakaxjt4q">
        <li data-id="element-26" data-mp="2eu4uz1py7har">Por qué el tiempo de reacción se puede mejorar y cuánto</li>
        <li data-id="element-27" data-mp="2jthryfaja4r2">La diferencia entre reacción simple y reacción con decisión</li>
        <li data-id="element-28" data-mp="2nvl6jcsi1pgk">
          La anticipación como sustituto del reflejo: por qué los mejores leen
          antes
        </li>
        <li data-id="element-29" data-mp="2sv7izk0i71ob">
          <strong data-id="element-30" data-mp="2suxq9oo2qgex">Ejercicios sin Equipamiento:</strong> Rebotes contra la pared,
          ejercicio de los dos colores, reacción a estímulos sonoros.
        </li>
        <li data-id="element-31" data-mp="ygoifmziv88x">
          <strong data-id="element-32" data-mp="ygeo5n7g2exf">Ejercicios con Compañero:</strong> Tiros con señal visual,
          engaño progresivo, series bajo fatiga.
        </li>
        <li data-id="element-33" data-mp="21sdgc7gyfxit">
          Progresión por Nivel (1 al 3) y cómo medir tu tiempo con el celular.
        </li>
      </ul>
}, {
  title: '🛡️ Módulo 5: Prevención de Lesiones Específicas del Arquero',
  image: MODULE_IMG_5,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-34" data-mp="25t5nmv69nscg">
        <li data-id="element-35" data-mp="25se4wkxrpp3l">
          Por qué el arquero tiene un perfil de lesión diferente al jugador de
          campo
        </li>
        <li data-id="element-36" data-mp="2kolopk59koic">
          <strong data-id="element-37" data-mp="2kobybvgb4fc4">El Hombro:</strong> Manguito rotador, señales de alarma,
          ejercicios de fortalecimiento y movilidad.
        </li>
        <li data-id="element-38" data-mp="2tj9udber487o">
          <strong data-id="element-39" data-mp="2thoy9hcsgh7p">La Muñeca:</strong> Microtraumatismos, fortalecimiento,
          técnica para reducir impacto y uso de vendajes.
        </li>
        <li data-id="element-40" data-mp="2pj9b9dgpj8ua">
          <strong data-id="element-41" data-mp="33gxnjwwpl7nq">La Rodilla:</strong> Riesgo de impacto lateral,
          fortalecimiento de cuádriceps/isquios, estabilidad de tobillo.
        </li>
        <li data-id="element-42" data-mp="2yj5uv0o8phih">
          Prevención General: Descanso, calentamiento específico y retorno al
          juego.
        </li>
      </ul>
}, {
  title: '🧘‍♂️ Módulo 6: El Juego Mental del Arquero',
  image: MODULE_IMG_6,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-43" data-mp="385gwgdalu14k">
        <li data-id="element-44" data-mp="384nlt18iyrh5">
          Por qué el puesto del arquero es mentalmente el más exigente del
          equipo
        </li>
        <li data-id="element-45" data-mp="3d2yydjq7fg32">
          Manejo de la Presión en Partido: minutos finales, ruido externo,
          respiración.
        </li>
        <li data-id="element-46" data-mp="2zbaj57knsbhv">
          La Recuperación Mental Después de un Gol: el ritual de reset y el
          error de culpar a otros.
        </li>
        <li data-id="element-47" data-mp="2pfqrixd4nyyx">
          <strong data-id="element-48" data-mp="2pg0hwm234855">Los Penales (7 metros):</strong> Rutina mental de 5 segundos,
          lectura del lanzador, el efecto de adivinar vs leer.
        </li>
        <li data-id="element-49" data-mp="2ge9czjfdc5cc">
          Visualización: Qué es, cómo hacerla en 5 minutos y situaciones de
          presión.
        </li>
      </ul>
}, {
  title: '👁️ Módulo 7: Lectura del Juego y Anticipación',
  image: MODULE_IMG_7,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-50" data-mp="30u2h2bxtdvej">
        <li data-id="element-51" data-mp="2vwaqbl8wofbx">
          Por qué la anticipación vale más que el reflejo más rápido del mundo
        </li>
        <li data-id="element-52" data-mp="2qx7i5rxmpszq">La diferencia entre leer el juego y adivinar</li>
        <li data-id="element-53" data-mp="2qvmr4caiws6m">
          Lectura del Lanzador Individual: señales previas (apoyo, cadera,
          hombro).
        </li>
        <li data-id="element-54" data-mp="2m0h4fb9ar9hh">Lectura por puesto: extremo, central, pivote, 9 metros.</li>
        <li data-id="element-55" data-mp="2hy2lys9jibqq">
          Lectura del Sistema de Juego Rival y ajustes durante el partido.
        </li>
      </ul>
}];
const BONUSES = [{
  title: '🎁 Bonus 1: Rutina de Calentamiento Específica Pre-Partido',
  image: IMG_3,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-56" data-mp="237vd949c4738">
        <li data-id="element-57" data-mp="2396hf56ozguv">Activación articular de hombro, muñeca y tobillo (10 minutos)</li>
        <li data-id="element-58" data-mp="1y7h3nhs34p33">Progresión: movilidad → activación muscular → explosividad</li>
        <li data-id="element-59" data-mp="1u6f22uap40xy">
          Cómo adaptar la rutina si llegás con 5 minutos antes del partido
        </li>
      </ul>
}, {
  title: '🎁 Bonus 2: Plan de Fortalecimiento de Hombro y Muñeca (4 semanas)',
  image: IMG_3,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-60" data-mp="dowui1ljorvp">
        <li data-id="element-61" data-mp="ipub49qwpdv3">Semana 1-2: activación y base (sin carga)</li>
        <li data-id="element-62" data-mp="iqdrhm0wru70">Semana 3-4: progresión con banda elástica</li>
        <li data-id="element-63" data-mp="noxfdrz2bg20">Ejercicios sin gimnasio, hacibles en el hogar</li>
      </ul>
}, {
  title: '🎁 Bonus 3: Guía de Atajada de Penales (7 metros)',
  image: IMG_1,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-64" data-mp="3r54gpru0917m">
        <li data-id="element-65" data-mp="3r5xl4m5hreml">Las zonas estadísticamente más jugadas en el amateur</li>
        <li data-id="element-66" data-mp="3w47h2yz1ij99">Cómo posicionarte para cubrirlas sin adivinar</li>
        <li data-id="element-67" data-mp="4pt8opuztydi">Rutina mental de los 5 segundos antes del tiro</li>
      </ul>
}, {
  title: '🎁 Bonus 4: Plan de Entrenamiento de Reflejos en Casa',
  image: IMG_4,
  content: <ul className="space-y-2 list-disc pl-4" data-id="element-68" data-mp="33dz3zljd2p1j">
        <li data-id="element-69" data-mp="38duxurych03d">Ejercicios con pelota de tenis o similar, sin cancha</li>
        <li data-id="element-70" data-mp="2f7dlcornx4nr">Progresión de 4 semanas</li>
        <li data-id="element-71" data-mp="2f6bwnhhq4jnk">Cómo integrarlo sin afectar el entrenamiento del equipo</li>
      </ul>
}];
const FAQS = [{
  title: '¿Es para mi nivel?',
  content: 'Sí, el manual está diseñado para adaptarse a todos los niveles, desde infantiles que recién empiezan hasta adultos que compiten en ligas amateurs o semi-profesionales. Las progresiones te permiten avanzar a tu ritmo.'
}, {
  title: '¿Cómo recibo el manual?',
  content: 'Es un producto 100% digital en formato PDF. Una vez confirmado el pago, recibirás acceso inmediato en tu correo electrónico para descargarlo y leerlo en cualquier dispositivo.'
}, {
  title: '¿Necesito equipamiento especial para los ejercicios?',
  content: 'No. La gran mayoría de los ejercicios propuestos, especialmente los de los bonos, están pensados para hacerse en casa o en el club sin necesidad de materiales costosos (solo pelotas de tenis, bandas elásticas o una pared).'
}];
const TESTIMONIALS = [{
  name: 'Martín, 24 años',
  city: 'CABA',
  text: '¡Increíble! Desde que apliqué el módulo de posicionamiento, mis atajadas en los extremos mejoraron un 100%. Recomendadísimo.'
}, {
  name: 'Lucas, 28 años',
  city: 'Córdoba',
  text: 'Siempre sufría con los penales, ahora sé exactamente qué mirar antes de que tiren. Vale cada peso.'
}, {
  name: 'Diego, 31 años',
  city: 'Rosario',
  text: 'El plan de fortalecimiento me salvó el hombro. Ya no termino los partidos con dolor, la prevención es clave.'
}, {
  name: 'Facundo, 22 años',
  city: 'Mendoza',
  text: 'La parte mental es oro puro. Me ayudó muchísimo a no caerme después de un error tonto y seguir enfocado.'
}, {
  name: 'Tomás, 26 años',
  city: 'La Plata',
  text: 'Muy completo y fácil de entender. Los ejercicios en casa me vinieron bárbaro para los días que no entreno con el equipo.'
}];
function scrollToCompra() {
  const el = document.getElementById('compra');
  if (el) el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
function goToCheckout() {
  if ((window as any).fbq) (window as any).fbq('track', 'InitiateCheckout');
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
}
// `final` = the button inside the purchase section -> goes to checkout.
// Any other button -> scrolls to the purchase section.
function BuyButton({
  className = '',
  final = false
}: {
  className?: string;
  final?: boolean;
}) {
  return <button type="button" onClick={final ? goToCheckout : scrollToCompra} className={`block w-full bg-[#c6ff2e] hover:bg-[#a4e000] text-black font-bold text-xl py-4 px-8 rounded-xl text-center transition-all transform hover:scale-[1.02] active:scale-95 shadow-[0_0_20px_rgba(198,255,46,0.3)] ${className}`} data-id="element-72" data-mp="33dk6zb47zcjb">
      <span className="flex items-center justify-center gap-2" data-id="element-73" data-mp="3hb8picate7l7">
        QUIERO SALVAR LOS PARTIDOS <ArrowRight className="w-6 h-6" data-id="element-74" data-mp="3m4bjumnf1l2g" />
      </span>
    </button>;
}
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-zinc-300 selection:bg-[#c6ff2e] selection:text-black font-sans overflow-x-hidden" data-id="element-75" data-mp="1amykqu1jx5u3">
      <PurchasePopup data-id="element-76" data-mp="15nlwq5yy1spx" />

      {/* HERO SECTION */}
      <header className="pt-12 pb-8 px-4 max-w-4xl mx-auto text-center" data-id="element-77" data-mp="1kd1bsop449ps">
        <h1 className="text-2xl md:text-4xl font-display font-black text-white leading-[1.05] mb-4 uppercase tracking-tight" data-id="element-78" data-mp="1feq3wjido9a7">
          Dejá de Adivinar en los Penales.{' '}
          <span className="text-[#c6ff2e]" data-id="element-79" data-mp="mqlupo0lle2r">
            Aprendé a Leer al Lanzador Antes de que Tire.
          </span>
        </h1>

        <button type="button" onClick={scrollToCompra} className="block w-full relative max-w-md mx-auto mb-8 group" aria-label="Ir a la compra" data-id="element-80" data-mp="11o4rndnfixla">
          <div className="absolute inset-0 bg-[#c6ff2e] blur-3xl opacity-20 group-hover:opacity-30 transition-opacity rounded-full" data-id="element-81" data-mp="2d28m0kxxinqv"></div>
          <img src={PRODUCT_IMAGE} alt="Arquero Handball Pro Manual" className="w-full h-auto relative z-10 drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-82" data-mp="283nk8h313w0b" />
        </button>

        <p className="text-base md:text-lg text-zinc-400 mb-6 max-w-xl mx-auto font-medium leading-snug" data-id="element-83" data-mp="qnrkc0g4ljwc">
          Posicionamiento, atajada por zona, reflejos y juego mental — todo lo
          que el entrenamiento de equipo nunca te da, en un solo manual.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8" data-id="element-84" data-mp="10jl7edrh0vsd">
          <div className="flex items-center gap-1.5 text-white text-xs md:text-sm font-semibold bg-zinc-900/80 px-3 py-1.5 rounded-full border border-zinc-800" data-id="element-85" data-mp="15j7j2irni3z2">
            <FileText className="w-4 h-4 text-[#c6ff2e]" data-id="element-86" data-mp="1edluubcz2wdf" /> 100% PDF
          </div>
          <div className="flex items-center gap-1.5 text-white text-xs md:text-sm font-semibold bg-zinc-900/80 px-3 py-1.5 rounded-full border border-zinc-800" data-id="element-87" data-mp="1jc6uo9obbe1c">
            <Zap className="w-4 h-4 text-[#c6ff2e]" data-id="element-88" data-mp="1objjv12nox73" /> Entrega Inmediata
          </div>
          <div className="flex items-center gap-1.5 text-white text-xs md:text-sm font-semibold bg-zinc-900/80 px-3 py-1.5 rounded-full border border-zinc-800" data-id="element-89" data-mp="1yg01nzzp4odj">
            <BookOpen className="w-4 h-4 text-[#c6ff2e]" data-id="element-90" data-mp="1oghfdcwbcqib" /> 7 Módulos + 6 Bonos
          </div>
        </div>

        <div className="max-w-md mx-auto" data-id="element-91" data-mp="1kg7ay4o6685k">
          <BuyButton data-id="element-92" data-mp="1kh8mea93kwnt" />
        </div>

        <HeroReviewCarousel data-id="element-93" data-mp="2h5ewvdspaja0" />
      </header>

      {/* PROBLEMS SECTION */}
      <section className="py-16 px-4 bg-zinc-900/30 border-y border-zinc-800/50" data-id="element-94" data-mp="2h7j0dumotg9r">
        <div className="max-w-3xl mx-auto" data-id="element-95" data-mp="2c7de6tz6slz2">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white text-center mb-10" data-id="element-96" data-mp="27fd96n49f2vm">
            Ser arquero, puede ser muy difícil...
          </h2>

          <div className="space-y-4 mb-12" data-id="element-97" data-mp="23c73bgl27dpo">
            {['Te sentís frustrado cuando te hacen goles por el mismo lado y no sabés cómo corregirlo.', 'Dudás si salir o quedarte en los contraataques y terminás a mitad de camino.', 'Te duele el hombro o la muñeca después de cada partido por mala técnica.', 'Sentís que la presión te come la cabeza después de recibir un gol tonto.', 'Adivinás en los penales en lugar de leer los movimientos del lanzador.'].map((problem, i) => <div key={i} className="flex items-start gap-4 bg-zinc-900/50 p-4 rounded-xl border border-zinc-800/50" data-id="element-98" data-mp="ofw49ceqot4e" data-mpi={i}>
                <AlertTriangle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-99" data-mp="fh21t5eq98ix" />
                <p className="text-lg text-zinc-300" data-id="element-100" data-mp="j9o8isqqu7d">{problem}</p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-101" data-mp="5i35mmb5f5ct">
            <h3 className="text-3xl font-display font-bold text-[#c6ff2e] mb-8" data-id="element-102" data-mp="5iuyhpdd2oze">
              Para eso está Arquero Handball Pro
            </h3>
          </div>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-103" data-mp="1zu9om7aaaqfo">
        <ModuleCarousel items={MODULES} data-id="element-104" data-mp="3kfg79sn9zd7x" />
      </section>

      {/* REVIEWS SECTION */}
      <section className="py-16 px-4 bg-[#c6ff2e] text-black" data-id="element-105" data-mp="3fg37y8f7wdog">
        <div className="max-w-4xl mx-auto" data-id="element-106" data-mp="3fdh2cebw088v">
          <h2 className="text-3xl md:text-4xl font-display font-black text-center mb-12 uppercase" data-id="element-107" data-mp="3u59gwo3uxi9j">
            Lo que dicen otros arqueros
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-108" data-mp="3pbojax66eqav">
            {TESTIMONIALS.slice(0, 3).map((review, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-xl" data-id="element-109" data-mp="2yoj8ljarc3j" data-mpi={i}>
                <div className="flex gap-1 mb-4" data-id="element-110" data-mp="gxo55lffdcw0">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-black text-black" data-id="element-111" data-mp="byustwbvjrxf" data-mpi={j} />)}
                </div>
                <p className="font-medium mb-4 italic" data-id="element-112" data-mp="2io9egznspn1s">"{review.text}"</p>
                <div className="font-bold" data-id="element-113" data-mp="2dpy6kuh29mm7">{review.name}</div>
                <div className="text-sm opacity-70" data-id="element-114" data-mp="2drj2ooj0xdm6">{review.city}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-115" data-mp="1wuu1ctsth9sy">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white text-center mb-4" data-id="element-116" data-mp="21mlpyysex5gg">
          También te llevás <span className="text-[#c6ff2e]" data-id="element-117" data-mp="26m85xfzmkzsy">GRATIS</span> con
          tu compra:
        </h2>
        <p className="text-center text-zinc-400 mb-10 uppercase tracking-wider text-sm font-bold" data-id="element-118" data-mp="18y6fmpk87bbg">
          *Bonos gratuitos solo por el día de hoy*
        </p>

        <Accordion items={BONUSES} data-id="element-119" data-mp="1dz3vgvhrjt9s" />
      </section>

      {/* COMPARISON SECTION */}
      <section className="py-16 px-4 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-120" data-mp="1iujahqribv7s">
        <div className="max-w-4xl mx-auto" data-id="element-121" data-mp="1nvytzee1dto2">
          <div className="grid grid-cols-2 gap-2 md:gap-8" data-id="element-122" data-mp="1nsukc1hsy5q0">
            {/* SIN */}
            <div className="bg-zinc-900 border border-red-900/30 rounded-2xl p-4 md:p-8" data-id="element-123" data-mp="2uddj1ne6ldzk">
              <h3 className="text-xl md:text-2xl font-display font-bold text-red-500 mb-6 text-center" data-id="element-124" data-mp="2z8j6wrr592qa">
                Sin Arquero Pro
              </h3>
              <ul className="space-y-4" data-id="element-125" data-mp="innuegeh8brn">
                {['Adivinás en los penales', 'Mala ubicación en el arco', 'Dolores de hombro/muñeca', 'Frustración tras un gol', 'Entrenamiento genérico'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm md:text-base text-zinc-400" data-id="element-126" data-mp="40kyge5syb6f" data-mpi={i}>
                    <XCircle className="w-5 h-5 text-red-500 shrink-0" data-id="element-127" data-mp="3r37jd384780w" />
                    <span data-id="element-128" data-mp="3r5kaa5vuosq3">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* CON */}
            <div className="bg-zinc-900 border border-[#c6ff2e]/30 rounded-2xl p-4 md:p-8 relative overflow-hidden" data-id="element-129" data-mp="1pcmf43elpo1z">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#c6ff2e]/10 blur-3xl rounded-full" data-id="element-130" data-mp="1kekuvf5fviox"></div>
              <h3 className="text-xl md:text-2xl font-display font-bold text-[#c6ff2e] mb-6 text-center" data-id="element-131" data-mp="2c6t254j3vy04">
                Con Arquero Pro
              </h3>
              <ul className="space-y-4 relative z-10" data-id="element-132" data-mp="22h12hvw5geos">
                {['Leés al lanzador antes', 'Posicionamiento automático', 'Técnica que previene lesiones', 'Mentalidad de acero', 'Ejercicios específicos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm md:text-base text-white font-medium" data-id="element-133" data-mp="1og6uvfgxehr6" data-mpi={i}>
                    <CheckCircle2 className="w-5 h-5 text-[#c6ff2e] shrink-0" data-id="element-134" data-mp="1ekdgdqjnce6r" />
                    <span data-id="element-135" data-mp="3dwg2z9nkhoon">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="mt-10 max-w-2xl mx-auto text-center text-lg md:text-2xl font-display font-bold text-white leading-snug" data-id="element-136" data-mp="38ywme33ecztj">
            No hay posición más solitaria en una cancha de handball que la tuya.{' '}
            <span className="text-[#c6ff2e]" data-id="element-137" data-mp="3lenxsofumir8">
              Tampoco hay una más importante.
            </span>
          </p>
        </div>
      </section>

      {/* OFFER SECTION */}
      <section id="compra" className="scroll-mt-4 py-16 px-4 max-w-md mx-auto text-center" data-id="element-138" data-mp="3v4z42hn0941a">
        <div className="bg-zinc-900 border-2 border-[#c6ff2e] rounded-3xl p-8 relative shadow-[0_0_50px_rgba(198,255,46,0.1)]" data-id="element-139" data-mp="2yhc9yqdelxr0">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#c6ff2e] text-black font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-140" data-mp="32j656j4ty9js">
            Oferta Especial
          </div>

          <h2 className="text-2xl font-display font-bold text-white mb-6" data-id="element-141" data-mp="mq79j2b89zgq">
            Resumen de tu pedido:
          </h2>

          <ul className="text-left space-y-3 mb-8 text-zinc-300" data-id="element-142" data-mp="ros70tz3i51h">
            <li className="flex items-center gap-2" data-id="element-143" data-mp="rr4q5aglalg4">
              <CheckCircle2 className="w-5 h-5 text-[#c6ff2e]" data-id="element-144" data-mp="1zuy8sau130l" /> Manual Arquero
              Handball Pro
            </li>
            <li className="flex items-center gap-2" data-id="element-145" data-mp="3t77hrdz6tsjo">
              <CheckCircle2 className="w-5 h-5 text-[#c6ff2e]" data-id="element-146" data-mp="bzltiw77vm1q" /> Bonus 1:
              Calentamiento
            </li>
            <li className="flex items-center gap-2" data-id="element-147" data-mp="71agydpjexft">
              <CheckCircle2 className="w-5 h-5 text-[#c6ff2e]" data-id="element-148" data-mp="3fg2dtzosee3j" /> Bonus 2:
              Fortalecimiento
            </li>
            <li className="flex items-center gap-2" data-id="element-149" data-mp="3ahhm6onlp2qp">
              <CheckCircle2 className="w-5 h-5 text-[#c6ff2e]" data-id="element-150" data-mp="3aev43v3334u8" /> Bonus 3: Guía
              Penales
            </li>
            <li className="flex items-center gap-2" data-id="element-151" data-mp="3p7osy748wxbk">
              <CheckCircle2 className="w-5 h-5 text-[#c6ff2e]" data-id="element-152" data-mp="3kedmi73ciik6" /> Bonus 4:
              Reflejos en Casa
            </li>
          </ul>

          <div className="mb-8" data-id="element-153" data-mp="2wn871t1bhsae">
            <p className="text-zinc-500 line-through text-xl mb-1" data-id="element-154" data-mp="2rqzzb0pg91d9">
              Precio normal: $58.990
            </p>
            <div className="text-5xl font-display font-black text-white" data-id="element-155" data-mp="177e9n0j4jpgr">
              $19.990{' '}
              <span className="text-lg text-zinc-400 font-normal" data-id="element-156" data-mp="1bzxos1xgmsno">ARS</span>
            </div>
          </div>

          <div className="mb-6" data-id="element-157" data-mp="xbuhmp7olaxa">
            <div className="flex justify-between text-sm mb-2 text-[#c6ff2e] font-bold" data-id="element-158" data-mp="x8f1dj29tvua">
              <span data-id="element-159" data-mp="1279vhh5ov6tp">Cupos disponibles</span>
              <span data-id="element-160" data-mp="1pynlhggdaqbi">12 / 200</span>
            </div>
            <div className="w-full bg-zinc-800 rounded-full h-3 overflow-hidden" data-id="element-161" data-mp="1pwubpsagjpza">
              <div className="bg-[#c6ff2e] h-full w-[6%] rounded-full relative" data-id="element-162" data-mp="1uxi5glq2mkx7">
                <div className="absolute inset-0 bg-white/30 animate-pulse" data-id="element-163" data-mp="1gxh1gxeiexdi"></div>
              </div>
            </div>
          </div>

          <div className="mb-6" data-id="element-164" data-mp="1l1x66vcdzyr5">
            <p className="text-sm text-zinc-400 mb-2 uppercase tracking-wider font-bold" data-id="element-165" data-mp="5ikbnlai4453">
              La oferta termina en:
            </p>
            <Countdown data-id="element-166" data-mp="9m8i20nector" />
          </div>

          <BuyButton final data-id="element-167" data-mp="prtljik9s50f" />

          <div className="mt-5 border-t border-zinc-800 pt-4" aria-label="Métodos de pago aceptados" data-id="element-168" data-mp="ps3ad2tkw64j">
            <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.16em] text-zinc-500" data-id="element-169" data-mp="l024pzqx1dnh">
              Pagá con el método que prefieras
            </p>
            <div className="flex items-center justify-center gap-2.5" role="list" data-id="element-170" data-mp="b2xg7t9ll63i">
              <div role="listitem" aria-label="Visa" className="flex h-7 w-12 items-center justify-center rounded-md bg-white px-1.5" data-id="element-171" data-mp="b0ui0lyak6np">
                <img src="https://raw.githubusercontent.com/datatrans/payment-logos/master/assets/cards/visa.svg" alt="Visa" className="max-h-4 max-w-full" data-id="element-172" data-mp="13r32ikgav35g" />
              </div>
              <div role="listitem" aria-label="Mastercard" className="flex h-7 w-12 items-center justify-center rounded-md bg-white px-1.5" data-id="element-173" data-mp="uqn0lff7g42p">
                <img src="https://raw.githubusercontent.com/datatrans/payment-logos/master/assets/cards/mastercard.svg" alt="Mastercard" className="max-h-4 max-w-full" data-id="element-174" data-mp="3fhdndo1mnw8w" />
              </div>
              <div role="listitem" aria-label="American Express" className="flex h-7 w-12 items-center justify-center rounded-md bg-white px-1.5" data-id="element-175" data-mp="1z0y5izy2cjkz">
                <img src="https://raw.githubusercontent.com/datatrans/payment-logos/master/assets/cards/american-express.svg" alt="American Express" className="max-h-4 max-w-full" data-id="element-176" data-mp="28r1azzmdfq07" />
              </div>
              <div role="listitem" aria-label="Apple Pay" className="flex h-7 w-12 items-center justify-center rounded-md bg-white px-1.5" data-id="element-177" data-mp="2iqiecae5hrt0">
                <img src="https://raw.githubusercontent.com/datatrans/payment-logos/master/assets/wallets/apple-pay.svg" alt="Apple Pay" className="max-h-4 max-w-full" data-id="element-178" data-mp="2rplub5i0tr3a" />
              </div>
            </div>
          </div>

          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-zinc-400" data-id="element-179" data-mp="20lgo9u8xvh77">
            <ShieldCheck className="w-4 h-4" data-id="element-180" data-mp="1vnov6wwk5p1f" /> Pago 100% Seguro
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-181" data-mp="29ohv5x5mpcbx">
        <h2 className="text-3xl font-display font-bold text-white text-center mb-10" data-id="element-182" data-mp="24nc0htserezr">
          Preguntas Frecuentes
        </h2>
        <Accordion items={FAQS} data-id="element-183" data-mp="2jjt9wfh1ejjo" />
      </section>

      {/* FOOTER */}
      <footer className="py-12 px-4 border-t border-zinc-800 text-center" data-id="element-184" data-mp="2emje8i321bne">
        <div className="flex items-center justify-center gap-2 mb-4 text-zinc-400" data-id="element-185" data-mp="2sdep1zx462tm">
          <Settings className="w-5 h-5" data-id="element-186" data-mp="2sfioa4k2idnk" />
          <span data-id="element-187" data-mp="2obkr3zeazcx5">Soporte: EbookDreamShop@gmail.com</span>
        </div>
        <p className="text-sm text-zinc-600" data-id="element-188" data-mp="32blrldqnoic3">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}